"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.createCacheManager = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var createCacheManager = function createCacheManager(cache, debug, readOnly) {
  return {
    createKey: function createKey(operation) {
      return {
        query: operation.query,
        variables: operation.variables
      };
    },
    read: function read(query) {
      try {
        return cache.readQuery(query);
      } catch (error) {
        if (debug) {
          window.console.log({
            message: 'Error --- Unable to read from cache',
            cacheKey: query,
            error: error
          });
        }
      }
    },
    write: function write(query, data) {
      if (readOnly) {
        if (debug) {
          window.console.log({
            message: 'ReadOnly --- this link will NOT write to the cache but it would have attempted to',
            cacheKey: query,
            data: data
          });
        }

        return;
      }

      try {
        cache.writeQuery((0, _extends2.default)({}, query, {
          data: data
        }));

        if (debug) {
          window.console.log({
            message: 'Success --- Updated the cache upon a mutation',
            cacheKey: query,
            data: data
          });
        }
      } catch (error) {
        if (debug) {
          window.console.log({
            message: 'Error --- Unable to write to the cache',
            cacheKey: query,
            data: data,
            error: error
          });
        }
      }
    }
  };
};

exports.createCacheManager = createCacheManager;